import { render, staticRenderFns } from "./AhorroConsumoComponent.vue?vue&type=template&id=c9aa20d8&scoped=true&"
import script from "./AhorroConsumoComponent.vue?vue&type=script&lang=js&"
export * from "./AhorroConsumoComponent.vue?vue&type=script&lang=js&"
import style0 from "./AhorroConsumoComponent.vue?vue&type=style&index=0&id=c9aa20d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9aa20d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VCol,VContainer,VDivider,VRow})
